import { Stack } from '@mui/material'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import ActivationGroupCard from '@/features/activationGroup/components/ActivationGroupCard'
import GenericActivationGroupPrequalificationPatternsDataGrid from '@/features/activationGroup/components/GenericActivationGroupPrequalificationPatternsDataGrid'
import { ActivationGroupRouteInformation } from '@/features/activationGroup/constants'
import { useActivationGroupDetails } from '@/features/activationGroup/pages/ActivationGroupDetails'

function ActivationGroupPrequalificationPatterns() {
  const { activationGroupUuid } = useParams()
  const { t } = useTranslation()

  const { setPageConfig } = useActivationGroupDetails()

  useEffect(() => {
    setPageConfig({
      title: t('activation_groups.tabs.prequalification_patterns'),
      activeTab: ActivationGroupRouteInformation.ACTIVATION_GROUP_PREQUALIFICATION_PATTERNS.routePath,
    })
  }, [])

  if (!activationGroupUuid) {
    return null
  }

  return (
    <Stack direction="column" marginY={3} spacing={3}>
      <ActivationGroupCard />
      <GenericActivationGroupPrequalificationPatternsDataGrid activationGroupUuid={activationGroupUuid} />
    </Stack>
  )
}

export default ActivationGroupPrequalificationPatterns
